import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GROUPS_DETAILS_ROUTES } from './group-details/group-details-routes';
import { GROUPS_ROUTES } from './groups.routes';

const routes: Routes = [...GROUPS_ROUTES, ...GROUPS_DETAILS_ROUTES];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GroupsRoutingModule {}
